import { render } from "./ColoredValue.vue?vue&type=template&id=203cb8e4&scoped=true&ts=true"
import script from "./ColoredValue.vue?vue&type=script&lang=ts"
export * from "./ColoredValue.vue?vue&type=script&lang=ts"

import "./ColoredValue.vue?vue&type=style&index=0&id=203cb8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203cb8e4"]])

export default __exports__